// Module
var code = "<wp-header params=\"logo: 'bad-panda-logo'\"></wp-header>\r\n<div id=\"body-section\">\r\n  <div>\r\n    <!-- ko if: view -->\r\n    <div data-bind=\"component: view\"></div>\r\n    <!-- /ko -->\r\n  </div>\r\n</div>\r\n<bp-footer></bp-footer>\r\n";
// Exports
module.exports = code;